// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_eR","advertDetailContacts__header":"c-n_eS"};